import useAppTheme from 'hooks/useAppTheme';
import { useAppSelector } from 'store/hook';
import type { Asset } from 'types/asset.types';
import { AssetCard, StyledCheckBox } from './AssetCard.styles';
import AssetCardItemHeader from './AssetCardItemHeader';
import AssetCardItemBody from './AssetCardItemBody';

interface Props {
  asset: Asset;
  showCheckedButton: boolean;
  checkedList: string[];
  handleCheckBoxSelected?: any;
  dateComparer?: string;
  handleAssetSelected?: any;
}
export function AssetCardItem({
  asset,
  checkedList,
  showCheckedButton,
  handleCheckBoxSelected,
  dateComparer = 'day',
  handleAssetSelected,
}: Props) {
  const { enableDarkTheme } = useAppTheme();

  const { notifications } = useAppSelector(
    (state) => state.ruleNotificationsReducer
  );

  const { assetId } = asset;

  const assetNotifications = notifications.filter(
    (item) => item.assetId === assetId
  );

  return (
    <AssetCard
      enabledarktheme={enableDarkTheme}
      key={assetId}
      style={{ position: 'relative' }}
    >
      {showCheckedButton && (
        <>
          <StyledCheckBox
            enabledarktheme={enableDarkTheme}
            checked={checkedList.includes(assetId)}
            onChange={(e) => {
              if (!e.target.value) return;
              handleCheckBoxSelected(assetId);
            }}
          />
        </>
      )}
      {/* header */}
      <AssetCardItemHeader
        asset={asset}
        showCheckedButton={showCheckedButton}
        checkedList={checkedList}
        handleCheckBoxSelected={handleCheckBoxSelected}
        handleAssetSelected={handleAssetSelected}
        assetNotifications={assetNotifications}
      />
      {/* body */}
      <AssetCardItemBody asset={asset} dateComparer={dateComparer ?? ''} />
    </AssetCard>
  );
}

export default AssetCardItem;
